var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { stringify } from 'query-string';
var defaultOptions = {
    baseUrl: 'https://cloud.liquid-state.com/',
    baseS3Url: 'https://s3.ap-southeast-2.amazonaws.com/liquidstate-prod-apsoutheast2/',
};
var NetworkError = /** @class */ (function (_super) {
    __extends(NetworkError, _super);
    function NetworkError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NetworkError;
}(Error));
var UbiquityError = /** @class */ (function (_super) {
    __extends(UbiquityError, _super);
    function UbiquityError(message, response) {
        var _this = _super.call(this, message) || this;
        _this.response = response;
        return _this;
    }
    return UbiquityError;
}(Error));
var RequestExecutor = /** @class */ (function () {
    function RequestExecutor(identity, options) {
        var _this = this;
        this.identity = identity;
        this.options = options;
        this.execute = function (url, init) { return __awaiter(_this, void 0, void 0, function () {
            var r, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(url, init || { headers: this.headers() })];
                    case 1:
                        r = _b.sent();
                        if (!r.ok) {
                            throw new UbiquityError('Invalid request', r);
                        }
                        if (r.status === 204) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, r.json()];
                    case 2:
                        _a = _b.sent();
                        throw new NetworkError('A network error has occurred, unable to contact ubiquity.');
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }
    Object.defineProperty(RequestExecutor.prototype, "auth", {
        get: function () {
            return this.identity.apiKey ? "Token " + this.identity.apiKey : "Bearer " + this.identity.jwt;
        },
        enumerable: true,
        configurable: true
    });
    RequestExecutor.prototype.url = function (url, query) {
        return "" + this.options.baseUrl + url + (query ? "?" + stringify(query) : '');
    };
    RequestExecutor.prototype.headers = function (additionalHeaders) {
        return __assign({ Authorization: this.auth, 'Content-Type': 'application/json' }, additionalHeaders);
    };
    return RequestExecutor;
}());
export { RequestExecutor };
var UbiquityV2Client = /** @class */ (function () {
    function UbiquityV2Client(identity, options) {
        var _this = this;
        this.identity = identity;
        this.listApps = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executor.execute(this.executor.url('api/v2/apps/'))];
            });
        }); };
        this.getApp = function (token) {
            return _this.executor.execute(_this.executor.url("api/v2/apps/" + token + "/"));
        };
        this.getForm = function (token, id, version) {
            return _this.executor.execute(_this.executor.url("api/v2/apps/" + token + "/content-lookup/forms/" + id + "/", version ? { version: version } : undefined));
        };
        this.getWeblink = function (token, id, version) {
            return _this.executor.execute(_this.executor.url("api/v2/apps/" + token + "/content-lookup/weblinks/" + id + "/", version ? { version: version } : undefined));
        };
        if (!options) {
            this.options = defaultOptions;
        }
        this.options = __assign(__assign({}, defaultOptions), options);
        if (!this.options.baseUrl) {
            this.options.baseUrl = defaultOptions.baseUrl;
        }
        if (!this.options.baseS3Url) {
            this.options.baseS3Url = defaultOptions.baseS3Url;
        }
    }
    Object.defineProperty(UbiquityV2Client.prototype, "executor", {
        get: function () {
            if (!this._executor) {
                this._executor = new RequestExecutor(this.identity, this.options);
            }
            return this._executor;
        },
        enumerable: true,
        configurable: true
    });
    return UbiquityV2Client;
}());
export default UbiquityV2Client;
//# sourceMappingURL=client.js.map